import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { revenueFromCustomer: { getRevenueFromCustomer, } } = apiUrls;

export const GET_REVENUE_FROM_CUSTOMER_SUCCESS = 'GET_REVENUE_FROM_CUSTOMER_SUCCESS';
export const GET_REVENUE_FROM_CUSTOMER_LOADING = 'GET_REVENUE_FROM_CUSTOMER_LOADING';


export const getRevenueFromCustomerData = ({ vendor, fromDate, toDate }) => async (dispatch) => {
    try {

        if (vendor) {
            const requestData = {
                ...getRevenueFromCustomer,
                url: getRevenueFromCustomer.url.replace('{{vendor}}', vendor).replace('{{fromDate}}', fromDate)
                    .replace('{{toDate}}', toDate)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: GET_REVENUE_FROM_CUSTOMER_SUCCESS,
                data,
                vendor
            })
        }
    } catch (e) {

        dispatch({
            type: GET_REVENUE_FROM_CUSTOMER_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null,
                vendor
            }
        })
    }
}



export const handleLoader = (isLoading, vendor) => (dispatch) => {
    if (vendor) {
        dispatch({
            type: GET_REVENUE_FROM_CUSTOMER_LOADING,
            isLoading,
            vendor
        })
    }
}
